import React, { PureComponent } from 'react';
class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
    };
  }
  render() {
    if (this.state.hasError) {
      return <p className="uk-text-lead">Error spotted here! <span role="img" aria-label="pile of flames">🔥</span>!</p>;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/ErrorBoundary.js